const capitaliseFirstLetterOfText = (text) => text.slice(0, 1).toUpperCase() + text.slice(1);

export default capitaliseFirstLetterOfText;
